import React from 'react';
import { Job } from '../types';
import { GitHubLink } from './GitHubLink';
import { JobIcon } from './JobIcon';

interface JobSelectorProps {
  jobs: Job[];
  onJobSelect: (job: Job) => void;
}

export const JobSelector: React.FC<JobSelectorProps> = ({ jobs, onJobSelect }) => {

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      padding: '40px',
      backgroundColor: '#1a1a1a',
      minHeight: '100vh',
      color: 'white',
      position: 'relative'
    }}>
      <GitHubLink position="corner" />
      <h1 style={{ marginBottom: '40px', color: '#f0f0f0' }}>选择职业</h1>
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
        gap: '20px',
        maxWidth: '800px',
        width: '100%'
      }}>
        {jobs.map(job => (
          <div 
            key={job.id}
            onClick={() => onJobSelect(job)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '20px',
              backgroundColor: '#2a2a2a',
              borderRadius: '10px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              border: '2px solid transparent'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#3a3a3a';
              e.currentTarget.style.borderColor = '#4A90E2';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#2a2a2a';
              e.currentTarget.style.borderColor = 'transparent';
            }}
          >
            <JobIcon name={job.name} size={80} />
            <h3 style={{ marginTop: '15px', color: '#f0f0f0' }}>{job.name}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};
